import React from 'react';
import { Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { QRCodeImage } from './QRCodeImage';

interface ScanCodeProps {
  url: string;
}
const ScanCode: React.FC<ScanCodeProps> = ({ url }) => (
  <Flex flexDirection="column" justifyContent="center" alignItems="center">
    <Text fontWeight="bold" mb={3}>
      Scan the QR Code
    </Text>
    <QRCodeImage url={url} />
  </Flex>
);

export { ScanCode };
